<template>
  <b-sidebar
    id="add-new-plan-sidebar"
    :visible="isAddNewPlanSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    no-close-on-backdrop
    width="60em"
    shadow
    backdrop
    no-header
    left
    @hidden="resetPlanData"
    @change="(val) => $emit('update:is-add-new-plan-sidebar-active', val)"
  >

    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ $t('Create New Garden Plan')}}</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide"/>
      </div>

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>

      <!-- BODY -->
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="onSubmit">

          <!-- Name -->
            <b-form-group :label="$t('Name')" label-for="name">
              <b-form-input
                id="name" v-model="planData.name"
                autofocus
                :state="errors && ('name' in errors) ? false : null"
                trim autocomplete="off" placeholder=""
              />
              <b-form-invalid-feedback v-if="errors && ('name' in errors)"
                                       :state="errors && ('name' in errors) ? false : null">
                {{ errors.name[0]  }}
              </b-form-invalid-feedback>
            </b-form-group>


          <!-- device -->
          <b-form-group :label="$t('Device')" label-for="device" :state="null">
            <v-select v-model="planData.device_id"
                label="name" :reduce="val => val.device_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="devicesOptions" :clearable="true" input-id="device"
            />

            <b-form-invalid-feedback v-if="errors && ('device_id' in errors)"
                                     :state="errors && ('device_id' in errors) ? false : null">
              {{ errors.device_id[0]  }}
            </b-form-invalid-feedback>
          </b-form-group>


          <!-- Camp -->
          <b-form-group :label="$t('Camp')" label-for="camp" :state="null">
            <v-select
                v-model="planData.camp_id"
                label="name"
                :reduce="val => val.geofence_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="campsOptions"
                :clearable="false"
                input-id="camp"
            />
            <b-form-invalid-feedback v-if="errors && ('camp_id' in errors)"
                                     :state="errors && ('camp_id' in errors) ? false : null">
              {{ errors.camp_id[0]  }}
            </b-form-invalid-feedback>
          </b-form-group>


          <b-row>
            <b-col cols="6">
              <!-- leave camp time -->
              <b-form-group
                  :label="$t('Leave Camp Time')"
                  label-for="leave-camp"
                  :state="null">
                <flat-pickr v-model="planData.camp_leave"
                             class="form-control" :class="{ 'is-invalid' : errors && ('camp_leave' in errors) }"
                            :config="flatPickerConfig"
                            placeholder="HH:MM"
                />
                <b-form-invalid-feedback v-if="errors && ('camp_leave' in errors)"
                                         :state="errors && ('camp_leave' in errors) ? false : null">
                  {{ errors.camp_leave[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <!-- back camp time -->
              <b-form-group
                  :label="$t('Back Camp Time')"
                  label-for="back-camp"
                  :state="null">
                <flat-pickr v-model="planData.camp_back"
                            :state="null" class="form-control"
                            :class="{ 'is-invalid' : errors && ('camp_back' in errors) }"
                            :config="flatPickerConfig"
                            placeholder="HH:MM"
                />
                <b-form-invalid-feedback v-if="errors && ('camp_back' in errors)"
                                         :state="errors && ('camp_back' in errors) ? false : null">
                  {{ errors.camp_back[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <!-- irrigation area -->
              <b-form-group :label="$t('Irrigation Area')" label-for="irrigation" :state="null">
                <v-select
                    v-model="planData.irrigation"
                    label="name"
                    :reduce="val => val.geofence_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="irrigationAreasOptions"
                    :clearable="false"
                    input-id="irrigation"
                />
                <b-form-invalid-feedback v-if="errors && ('irrigation' in errors)"
                                         :state="errors && ('irrigation' in errors) ? false : null">
                  {{ errors.irrigation[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <!-- irrigation distance -->
              <b-form-group
                  :label="$t('Irrigation Distance')"
                  label-for="irrigation_distance"
                  :state="null">
                <b-form-input
                    id="irrigation_distance"
                    v-model="planData.irrigation_distance"
                    autofocus
                    :state="errors && ('irrigation_distance' in errors) ? false : null"
                    trim
                    autocomplete="off"
                    placeholder=""
                />

                <b-form-invalid-feedback v-if="errors && ('irrigation_distance' in errors)"
                                         :state="errors && ('irrigation_distance' in errors) ? false : null">
                  {{ errors.irrigation_distance[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <!-- irrigation duration -->
              <b-form-group
                  :label="$t('Irrigation Duration')"
                  label-for="irrigation_duration"
                  :state="null">
                <b-form-input
                    id="irrigation_duration"
                    v-model="planData.irrigation_duration"
                    autofocus
                    :state="errors && ('irrigation_duration' in errors) ? false : null"
                    trim
                    autocomplete="off"
                    placeholder=""
                />

                <b-form-invalid-feedback v-if="errors && ('irrigation_duration' in errors)"
                                         :state="errors && ('irrigation_duration' in errors) ? false : null">
                  {{ errors.irrigation_duration[0] }}
                </b-form-invalid-feedback>
              </b-form-group>

            </b-col>

            <b-col cols="12">
              <b-form-group :label="$t('work days')" label-for="work_days" :state="null">
                <b-form-checkbox-group
                    v-model="planData.work_days"
                    :options="daysOptions" name="flavour-1a">
                </b-form-checkbox-group>
                <b-form-invalid-feedback v-if="errors && ('work_days' in errors)"
                                         :state="errors && ('work_days' in errors) ? false : null">
                  {{ errors.work_days[0]  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <label>{{ $t('fill areas')}}</label>
              <area-form-repeater
                  :areas.sync="planData.fill_area"
                  :options="FillArea">
              </area-form-repeater>
            </b-col>

<!--            <b-col cols="10">-->


<!--              <area-form-repeater></area-form-repeater>-->


<!--              &lt;!&ndash; fill area &ndash;&gt;-->
<!--              <b-form-group :label="$t('Fill Area')" label-for="fill" :state="null">-->
<!--                <v-select multiple-->
<!--                          v-model="planData.fill_area"-->
<!--                          label="name"-->
<!--                          :reduce="val => val.geofence_id"-->
<!--                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
<!--                          :options="waterAreasOptions"-->
<!--                          :clearable="false"-->
<!--                          input-id="fill"-->
<!--                />-->
<!--                <b-form-invalid-feedback v-if="errors && ('fill_area' in errors)"-->
<!--                                         :state="errors && ('fill_area' in errors) ? false : null">-->
<!--                  {{ errors.fill_area[0]  }}-->
<!--                </b-form-invalid-feedback>-->
<!--              </b-form-group>-->
<!--            </b-col>-->

<!--            &lt;!&ndash; Value &ndash;&gt;-->
<!--            <b-col md="2">-->
<!--              <b-form-group :label="$t('Fill Count')" label-for="fill" :state="null">-->
<!--                  <b-form-input v-model="planData.fill_count" type="number"/>-->
<!--                <b-form-invalid-feedback v-if="errors && ('fill_count' in errors)"-->
<!--                                         :state="errors && ('fill_count' in errors) ? false : null">-->
<!--                  {{ errors.fill_count[0]  }}-->
<!--                </b-form-invalid-feedback>-->
<!--              </b-form-group>-->
<!--            </b-col>-->


            <b-col cols="12">
              <label>{{ $t('tanks areas')}}</label>
              <area-form-repeater :areas.sync="planData.tanks" :options="tankAreasOptions"></area-form-repeater>
            </b-col>


<!--            <b-col cols="12" class="mb-1 mt-2">-->
<!--                <b-button-->
<!--                    v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="">-->
<!--                  <feather-icon icon="PlusIcon" class="mr-25"/>-->
<!--                  <span>{{ $t('add area') }}</span>-->
<!--                </b-button>-->
<!--            </b-col>-->


<!--            <b-col cols="12">-->
<!--              <b-form-group :label="$t('Tanks Area')" label-for="tanks" :state="null">-->
<!--                &lt;!&ndash; Row Loop &ndash;&gt;-->
<!--                <div style="padding: 10px; border: 1px solid #d8d6de; border-radius: 0.357rem;" ref="tanksAreaRef">-->
<!--                  <b-row class="mb-1 mt-1 pb-0"-->
<!--                      v-for="(item, index) in planData.tanks" :id="item.geofence_id"-->
<!--                      :key="index" ref="rowRef">-->
<!--                    &lt;!&ndash; Item Key &ndash;&gt;-->
<!--                    <b-col md="8">-->
<!--                      <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
<!--                                :reduce="a => a.geofence_id" label="name" :options="tankAreasOptions" v-model="item.area"/>-->
<!--                    </b-col>-->

<!--                    &lt;!&ndash; Value &ndash;&gt;-->
<!--                    <b-col md="2">-->
<!--                      <b-form-input v-model="item.count" type="number"/>-->
<!--                    </b-col>-->

<!--                    &lt;!&ndash; Remove Button &ndash;&gt;-->
<!--                    <b-col md="1" class="">-->
<!--                      <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'"-->
<!--                                variant="outline-danger" class="mt-0 mt-md-0 btn-sm" @click="removeItem(index)">-->
<!--                        <feather-icon icon="XIcon" class="mr-25"/>-->
<!--                      </b-button>-->
<!--                    </b-col>-->

<!--                  </b-row>-->
<!--                </div>-->
<!--                <b-form-invalid-feedback v-if="errors && ('tanks' in errors)"-->
<!--                        :state="errors && ('tanks' in errors) ? false : null">{{ errors.tanks[0] }}-->
<!--                </b-form-invalid-feedback>-->
<!--              </b-form-group>-->
<!--            </b-col>-->

          </b-row>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ $t('create')}}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="resetPlanData">
              {{ $t('cancel')}}
            </b-button>
          </div>
        </b-form>

    </template>
  </b-sidebar>
</template>

<script>
import { BFormCheckboxGroup,
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BRow, BCol
} from 'bootstrap-vue'
import { onMounted, ref, toRefs } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'
import lang from '@/libs/i18n'
import AreaFormRepeater from '@/components/form/AreaFormRepeater'

export default {
  components: {
    AreaFormRepeater,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,BFormCheckboxGroup,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    OrbitSpinner,
    BRow, BCol,

    flatPickr,

  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewPlanSidebarActive',
    event: 'update:is-add-new-plan-sidebar-active',
  },
  props: {
    isAddNewPlanSidebarActive: {
      type: Boolean,
      required: true,
    },

    campsOptions: {
      type: Array|null,
      required: true,
    },

    irrigationAreasOptions: {
      type: Array|null,
      required: true,
    },

    tankAreasOptions: {
      type: Array|null,
      required: true,
    },

    waterAreasOptions: {
      type: Array|null,
      required: true,
    },

    devicesOptions: {
      type: Array|null,
      required: true,
    }

  },
  setup(props, { emit, root }) {

    console.log(props.waterAreasOptions)

    const FillArea = toRefs(props).waterAreasOptions


    const daysOptions = [
      { text: 'Saturday', value: 'Saturday' },
      { text: 'Sunday', value: 'sunday' },
      { text: 'Monday', value: 'monday' },
      { text: 'Tuesday', value: 'Tuesday' },
      { text: 'Wednesday', value: 'Wednesday' },
      { text: 'Thursday', value: 'Thursday' },
      { text: 'Friday', value: 'Friday' },
    ]

    const blankPlanData = {
      name: '',
      type: 'garden',
      camp_id: null,
      device_id: null,
      camp_leave: '',
      camp_back: '',
      fill_area: [
        {id:1, area: null, count: null}
      ],
      tanks: [
        {id:1, area: null, count: null}
      ],
      irrigation: null,
      irrigation_distance: null,
      irrigation_duration: null,
      work_days: []
    }


    const flatPickerConfig = {
      enableTime: true,
      noCalendar: true,
      time_24hr: true,
      dateFormat: "H:i:S",
    }

    const errors = ref(null)
    const requestStatus = ref(false)
    const planData = ref(JSON.parse(JSON.stringify(blankPlanData)))


    const resetPlanData = () => {
      planData.value = JSON.parse(JSON.stringify(blankPlanData))
    }

    const onSubmit = () => {
      errors.value = null
      requestStatus.value = true
      store.dispatch('plans/createPlan', planData.value)
        .then(res => {
          root.$bvToast.toast(lang.t('garden plan added successfully'), {
            title: lang.t("success"),
            variant: 'success',
            solid: false,
          })

          requestStatus.value = false
          emit('refetch-data')
          emit('update:is-add-new-plan-sidebar-active', false)

        }).catch(res => {
          requestStatus.value = false
          if (res.response?.status === 422) {
            errors.value = res.response.data.errors
            root.$bvToast.toast(lang.t(res.response.data.message), {
              title: lang.t('Validation Error'),
              variant: 'danger',
              solid: false,
            })
          }
        }
      )
    }



    return {
      FillArea,
      daysOptions,
      flatPickerConfig,
      planData,
      onSubmit,
      resetPlanData,
      requestStatus,
      errors
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
